const initializedForms = new WeakSet();

const getVacancyFilterForms = (scope) => {
  const forms = [];

  if (scope?.matches?.('form[data-vacancy-filters]')) {
    forms.push(scope);
  }

  forms.push(...(scope?.querySelectorAll?.('form[data-vacancy-filters]') || []));

  return forms;
};

const initVacancyFilterSubmission = (scope = document) => {
  getVacancyFilterForms(scope).forEach((form) => {
    if (initializedForms.has(form)) return;

    initializedForms.add(form);
    form.addEventListener('change', (event) => {
      if (!event.target?.matches?.('select') && !event.target?.matches?.('input[data-vacancy-keywords]')) return;
      if (typeof form.requestSubmit !== 'function') return;

      form.requestSubmit();
    });
  });
};

initVacancyFilterSubmission();
window.initVacancyFilterSubmission = initVacancyFilterSubmission;
